import React from 'react'

import ProductHighlights from '../../../react4xp/components/ProductHighlights'

function ProductHighlightsPart({ highlights }) {
    return (
        <ProductHighlights highlights={highlights} />
    )
}

export default (props) => <ProductHighlightsPart {...props} />
